import { render, staticRenderFns } from "./flowsDetails.vue?vue&type=template&id=4e30e822"
import script from "./flowsDetails.vue?vue&type=script&lang=js"
export * from "./flowsDetails.vue?vue&type=script&lang=js"
import style0 from "./flowsDetails.vue?vue&type=style&index=0&id=4e30e822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports